import React from 'react';
import PropTypes from 'prop-types';
import { A } from 'components/Typography';
import BaseModal from 'products/nomad_insurance/components/BaseModal';
import usePolicyLink from 'products/nomad_insurance/hooks/usePolicyLink';
import { MediumText } from '../../styled';

const ElectronicsTheftModal = ({ isOpen, onClose }) => {
  const policyLink = usePolicyLink();
  const splitLink = policyLink.split('?');

  const getSearchLink = (searchStr) => {
    const params = new URLSearchParams(splitLink[1]);
    params.append('search', searchStr);
    return `${splitLink[0]}?${params.toString()}`;
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      heading="Electronics theft add-on details"
    >
      <div>
        Covers electronics like laptops, tablets and cameras for up to $1000 per stolen
        item and yearly limit of $3000 per policy.
      </div>
      <div>
        You <MediumText>must have a proof of ownership</MediumText>, such as receipt, for
        the items you wish you cover with this add-on.{' '}
        <MediumText>
          <A href={getSearchLink('electronics theft')}>
            See full terms & conditions here
          </A>
        </MediumText>
      </div>
    </BaseModal>
  );
};

ElectronicsTheftModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ElectronicsTheftModal;
